import { useLocation } from 'react-router-dom';
import { PDFViewer } from '@react-pdf/renderer';
import ClientPDF from './ClientPDF';

function ClientPDFview() {
  const location = useLocation();
  const quotation = location.state?.quotation;
  const userDetails1 = location.state?.userDetails1;

  return (
    <PDFViewer  width="100%" height="950">
      <ClientPDF e={quotation } userDetails1={userDetails1} />
    </PDFViewer>
  );
}

export default ClientPDFview;
